module.exports = __webpack_public_path__ + "static/media/NumberCircle-02.fd7def4f.svg";